import React, { memo, useEffect } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import ProgressChart from 'root/src/client/web/base/ProgressChart'
import WidgetTask from 'root/src/client/web/record/WidgetTask'
import {
	BRAND_SETTINGS_ROUTE_ID, BRAND_PRODUCTS_AND_KEYS_ROUTE_ID,
} from 'root/src/shared/descriptions/routes/routeIds'
import { userGroups } from 'root/src/shared/constants/auth'
import Link from 'root/src/client/web/base/Link'
import { ltGtMediaQuery, smMediaQuery, ltSmMediaQuery, colorsNew } from 'root/src/client/web/commonStyles'
import progressCalculator from 'root/src/client/web/record/util/progressCalculator'
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls'

const style = {
	root: {
		backgroundColor: colorsNew.dark2,
		padding: [[20, 0]],
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-around',
		flexWrap: 'wrap',
		[smMediaQuery]: {
			padding: [[20, 13]],
		},
		[ltSmMediaQuery]: {
			padding: 20,
		},
	},
	oval: {
		border: '4px solid #2A3440',
		borderRadius: 300,
		width: 60,
		height: 60,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginRight: 20,
	},
	titleWrapper: {
		display: 'flex',
		alignItems: 'center',
		[smMediaQuery]: {
			width: '33%',
			flexDirection: 'column',
		},
		[ltSmMediaQuery]: {
			paddingBottom: 20,
		},
	},
	taskWrapper: {
		display: 'grid',
		gridAutoFlow: 'column',
		gap: 17,
		padding: 20,
		width: 'fit-content',
		maxWidth: 1300,
		justifyContent: 'end',
		'@media (max-width: 1518px)': {
			width: '100%',
			justifyContent: 'center',
			gap: 13,
		},
		[ltGtMediaQuery]: {
			gridTemplateColumns: 'repeat(2, 1fr)',
			gridAutoFlow: 'row',
			gap: 15,
		},
		[smMediaQuery]: {
			width: '60%',
			padding: 0,
		},
		'@media (max-width: 460px)': {
			width: 'auto',
			padding: 0,
			display: 'initial',
		},
	},
	task: {
		'@media (max-width: 900px)': {
			width: '45%',
			marginBottom: 10,
		},
	},
	title: {
		marginRight: 20,
		[smMediaQuery]: {
			margin: 10,
			textAlign: 'center',
		},
	},
	link: {
		[ltGtMediaQuery]: {
			paddingRight: '3%',
			paddingBottom: '3%',
		},
	},
	modalTask: {
		cursor: 'pointer',
	},
}

const stepsDesc = {
	brand: ({ hasBrandDetails, hasKeysAndProducts, hasDropEvent }) => [
		{ title: 'Add Publisher', completed: hasBrandDetails, routeId: BRAND_SETTINGS_ROUTE_ID },
		{ title: 'Add Keys or Product', completed: hasKeysAndProducts, routeId: BRAND_PRODUCTS_AND_KEYS_ROUTE_ID },
		{ title: 'Add a Campaign', completed: hasDropEvent, routeId: routeUrls.addCampaign() },
	],
}

const HelperWidget = memo(({
	classes, helperWidgetOnSuccess,
	introProjectCreated, widgetType, userRole, displayModal,
	...props
}) => {
	const stepsFn = stepsDesc[widgetType]
	if (!stepsFn) return null
	const steps = stepsFn(props)
	const progress = progressCalculator(steps)

	useEffect(() => {
		if (progress >= 100) {
			if (helperWidgetOnSuccess) helperWidgetOnSuccess()
		}
	}, [progress])
	const textMap = {
		[userGroups.brand]: 'Complete these steps to get started with Dare Drop',
	}
	return (
		<div className={classes.root}>
			<div className={classes.titleWrapper}>
				<ProgressChart percentage={progress} />
				<span className={classes.title}>{textMap[userRole]}</span>
			</div>
			<div className={classes.taskWrapper}>
				{steps.map(task => (task.completed ? (
					<WidgetTask
						key={task.title}
						title={task.title}
						completed={task.completed}
					/>
				) : task.routeId || task.href ? (
					<Link
						href={task.href}
						routeId={task.routeId}
						classes={{ link: classes.link }}
						key={task.title}
					>
						<WidgetTask title={task.title} completed={task.completed} />
					</Link>
				) : (
					<div
						key={task.title}
						className={classes.modalTask}
						onClick={() => {
							displayModal(task.modalId)
						}}
					>
						<WidgetTask title={task.title} completed={task.completed} />
					</div>
				)))}
			</div>
		</div>
	)
})

export default withStyles(style, { name: 'MuiHelperWidget' })(HelperWidget)
